import { unitStrict } from '@lib/style/unit';
import { FONTS } from '@packages/style/themes/default/fonts';
import { get } from 'lodash';
import { css } from 'styled-components';

export interface FontType {
    size: number | string;
    font: string;
    fallback?: string;
    weight?: number | string;
    variations?: string[] | number[];
}

export type FontsMap = Record<'primary' | 'secondary' | 'monospace' | 'icons', FontType>;

/**
 * @param size
 * @param weight
 * @param font
 * @returns {function({theme: *}): []|null|string|*}
 */
export function font(size?: number, weight?: number, font = 'primary') {
    return ({ theme }) => {
        const _font: FontType = get(theme.fonts || FONTS, font);
        const size$ = size ?? _font.size;
        const weight$ = weight ?? _font.weight;

        return css`
            font-family: ${_font.font}, ${_font.fallback};
            font-size: ${unitStrict(size$)};
            font-weight: ${weight$};
        `;
    };
}
